export interface CitationPhotoDto {
    id?: number;
    kind?: string | null;
    url?: string | null;
    capturedAtUtc?: string | null;
}
